import { ArrowDown, MapPin, QrCode, Star } from "lucide-react";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { LINKS } from "@/lib/store";

export const Hero = () => {
  const { hero } = useSiteSettings();
  return (
    <section id="top" className="relative overflow-hidden" data-testid="hero-section">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 pb-16 pt-10 sm:px-6 md:grid-cols-12 md:pt-16 lg:px-8 lg:pb-24">
        <div className="md:col-span-6 lg:col-span-5 flex flex-col justify-center">
          <div className="rise inline-flex w-fit items-center gap-2 rounded-full border border-[#C59B27]/40 bg-white/70 px-3 py-1.5 text-xs font-semibold text-[#8B5A2B]" data-testid="qr-welcome-chip">
            <QrCode className="h-3.5 w-3.5" /> Scanned our banner? Swagat hai!
          </div>
          <p className="rise mt-6 font-deva text-3xl text-[#8B5A2B]" style={{ animationDelay: "80ms" }} data-testid="namaste-greeting">
            नमस्ते <span className="font-display italic text-2xl text-[#1B4332]/80">· Namaste</span>
          </p>
          <h1 className="rise mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight text-[#1B4332]" style={{ animationDelay: "160ms" }}>
            RamVilas Kitchen <span className="text-[#C59B27]">&amp;</span> Hardware Store
          </h1>
          <p className="rise mt-6 max-w-md text-base sm:text-lg leading-relaxed text-[#3E4540]" style={{ animationDelay: "240ms" }}>
            Your neighbourhood shop in Mamura, Sector 66. Browse our kitchenware and hardware, then message us on WhatsApp — we'll help you find exactly the right size and fit.
          </p>
          <div className="rise mt-8 flex flex-col gap-3 sm:flex-row" style={{ animationDelay: "320ms" }}>
            <a href="#catalogue" data-testid="explore-products-btn"
               className="inline-flex h-12 items-center justify-center gap-2 rounded-full bg-[#1B4332] px-7 font-semibold text-[#FDFBF7] shadow-md transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#10291F]">
              Explore Products <ArrowDown className="h-4 w-4" />
            </a>
            <a href={LINKS.directions} target="_blank" rel="noopener noreferrer" data-testid="get-directions-btn"
               className="inline-flex h-12 items-center justify-center gap-2 rounded-full border-2 border-[#1B4332] px-7 font-semibold text-[#1B4332] transition-colors duration-300 hover:bg-[#1B4332] hover:text-[#FDFBF7]">
              <MapPin className="h-4 w-4" /> Get Directions
            </a>
          </div>
        </div>
        <div className="md:col-span-6 lg:col-span-7 relative rise" style={{ animationDelay: "200ms" }}>
          <div className="grain relative aspect-[4/3] overflow-hidden rounded-[2rem] rounded-tr-[6rem] border border-[#E5E0D8] shadow-[0_30px_60px_-30px_rgba(27,67,50,.45)]">
            <img src={hero || "/images/hero.jpg"} alt="Inside RamVilas Kitchen & Hardware Store" className="h-full w-full object-cover" fetchpriority="high" data-testid="hero-image" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#10291F]/40 via-transparent to-transparent" />
          </div>
          <a href={LINKS.reviews} target="_blank" rel="noopener noreferrer" data-testid="hero-reviews-link"
             className="absolute -bottom-5 left-4 sm:left-8 flex items-center gap-3 rounded-2xl border border-[#E5E0D8] bg-white px-4 py-3 shadow-lg transition-transform duration-300 hover:-translate-y-0.5">
            <span className="flex text-[#C59B27]">{[0, 1, 2, 3, 4].map((i) => <Star key={i} className="h-4 w-4 fill-current" />)}</span>
            <span className="text-sm font-semibold text-[#1F2421]">Read our Google reviews</span>
          </a>
        </div>
      </div>
      <div className="rangoli-border opacity-60" />
    </section>
  );
};
